import { useTranslation } from "react-i18next";
import Modal from "../../../../components/common/Modal";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { useState } from "react";
import OutlinedButton from "../../../../components/common/OutlinedButton";
import PrimaryButton from "../../../../components/common/PrimaryButton";

interface ISettlementJourneyModalProps {
  handleClose: () => void;
  modalOpen: boolean;
}

interface Step {
  step: number;
  image: string;
  title: string;
  description: string;
}

const SettlementJourneyModal = ({
  modalOpen,
  handleClose,
}: ISettlementJourneyModalProps) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);

  const steps: Step[] = [
    {
      step: 1,
      image: "/assets/images/svg/journey1.svg",
      title: t("lbl_journey1_title"),
      description: t("lbl_journey1_description"),
    },
    {
      step: 2,
      image: "/assets/images/svg/journey2.svg",
      title: t("lbl_journey2_title"),
      description: t("lbl_journey2_description"),
    },
    {
      step: 3,
      image: "/assets/images/svg/journey3.svg",
      title: t("lbl_journey3_title"),
      description: t("lbl_journey3_description"),
    },
  ];

  const handlePrev = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentStep === steps.length) {
      handleClose();
      return;
    }

    setCurrentStep((prev) => prev + 1);
  };

  return (
    <Modal visible={modalOpen} onCancel={handleClose}>
      <div className={classNames(styles.container)}>
        <img src={steps[currentStep - 1].image} alt="" />
        <h1>{steps[currentStep - 1].title}</h1>
        <p>{steps[currentStep - 1].description}</p>

        <div className={classNames(styles.buttonsContainer)}>
          <PrimaryButton
            onClick={handleNext}
            style={{
              height: "52px",
              borderRadius: "8px",
              textAlign: "center",
              whiteSpace: "nowrap",
              fontSize: "1rem",
              lineHeight: "100%",
              fontWeight: 500,
              background: "#0D44AD",
              flex: 2,
            }}>
            {`${t("lbl_next_button")} (${currentStep}/${steps.length})`}
          </PrimaryButton>
          <OutlinedButton
            disabled={currentStep === 1}
            onClick={handlePrev}
            style={{
              color: currentStep === 1 ? "#C7CBD7" : "#0D44AD",
              background: currentStep === 1 ? "#E2E5EE" : "#F3F6FC",
              border: "none",
              fontSize: "1rem",
              fontWeight: 500,
              height: "52px",
              flex: 1,
              cursor: currentStep === 1 ? "not-allowed" : "pointer",
            }}>
            {t("lbl_prev")}
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default SettlementJourneyModal;
